import clsx from 'clsx';
import { forwardRef, PropsWithChildren } from 'react';

export interface PanelFooterProps {
  className?: string | undefined;
}

export const PanelFooter = forwardRef<HTMLDivElement, PropsWithChildren<PanelFooterProps>>(function PanelFooterFr(
  { children, className },
  ref,
) {
  return (
    <div className={clsx(`WindowPanel-footer`, className)} ref={ref}>
      {children}
    </div>
  );
});
